package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.BrandChip
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.shared.dto.integration.IntegrationProviderDto
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image

enum class Brand(val asset: String, val label: String) {
    Slack("/brand/slack.svg", "Slack"),
    Linear("/brand/linear.svg", "Linear"),
    GitHub("/brand/github.svg", "GitHub"),
    GoogleCalendar("/brand/google.svg", "Google Calendar"),
    Claude("/brand/claude.svg", "Claude"),
}

fun IntegrationProviderDto.brand(): Brand? = when (this) {
    IntegrationProviderDto.SLACK -> Brand.Slack
    IntegrationProviderDto.LINEAR -> Brand.Linear
    IntegrationProviderDto.GITHUB -> Brand.GitHub
    IntegrationProviderDto.GOOGLE_CALENDAR -> Brand.GoogleCalendar
    IntegrationProviderDto.ANTHROPIC -> Brand.Claude
    IntegrationProviderDto.UNKNOWN -> null
}

@Composable
fun BrandLogo(
    brand: Brand,
    sizePx: Int = LOGO_PX,
    glyphPx: Int = GLYPH_PX,
    dimmed: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = Modifier
            .styleModifier {
                property("width", "${sizePx}px")
                property("height", "${sizePx}px")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("flex-shrink", "0")
                property("box-sizing", "border-box")
                property("border-radius", Radius.md.toString())
                property("background-color", BrandChip.BACKGROUND)
                property("border", "1px solid ${BrandChip.BORDER}")
                if (dimmed) {
                    property("filter", BrandChip.DIMMED_FILTER)
                    property("opacity", BrandChip.DIMMED_OPACITY)
                }
            }
            .then(modifier),
    ) {
        Image(
            src = brand.asset,
            description = brand.label,
            modifier = Modifier.styleModifier {
                property("width", "${glyphPx}px")
                property("height", "${glyphPx}px")
                property("display", "block")
            },
        )
    }
}

private const val LOGO_PX = 40
private const val GLYPH_PX = 22
